// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const batchService = {
    checkStatus,
    getRecent,

    assignCapabilitiesUnassignedApplications,
    assignCapabilitiesSpecifiedApplications
};

function checkStatus(id) {
    return axios.get(`/batchprocess/status/${id}`).then(handleResponse);
}

function getRecent() {
    return axios.get(`/batchprocess/recent`).then(handleResponse);
}

function assignCapabilitiesUnassignedApplications() {
    return axios.post(`/batchprocess/assign_capabilities_unassigned_applications`).then(handleResponse);
}

function assignCapabilitiesSpecifiedApplications(applicationIds) {
    return axios.post(`/batchprocess/assign_capabilities_specified_applications`, applicationIds ).then(handleResponse);
}
